class PowerSupply {
  constructor($root) {
    if (!$root.length) return
    this.$root = $root

    this.$seoIndexableField = $root.find('.js-seo-indexable')
    this.$isEnabledField = $root.find('.js-is-enabled')
    this.$switch = $root.find('.power-supply__switch')

    $root.on('click', '.power-supply__switch-state--enable', this.handleEnable.bind(this))
    $root.on('click', '.power-supply__switch-state--hide', this.handleHide.bind(this))
    $root.on('click', '.power-supply__switch-state--disable', this.handleDisable.bind(this))
  }

  handleEnable() {
    if (confirm('Are you sure you want to enable this website?')) {
      this.$isEnabledField.val('true')
      this.$seoIndexableField.val('true')
      this.$switch.attr('class', 'power-supply__switch power-supply__switch--enabled')
      this.$root.submit()
    }
  }

  handleHide() {
    if (confirm('Are you sure you want to hide this website?')) {
      this.$isEnabledField.val('true')
      this.$seoIndexableField.val('false')
      this.$switch.attr('class', 'power-supply__switch power-supply__switch--hidden')
      this.$root.submit()
    }
  }

  handleDisable() {
    if (confirm('Are you sure you want to disable this website?')) {
      this.$isEnabledField.val('false')
      this.$seoIndexableField.val('false')
      this.$switch.attr('class', 'power-supply__switch power-supply__switch--disabled')
      this.$root.submit()
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  return new PowerSupply($('.power-supply'))
})
